module.exports = __webpack_public_path__ + "static/media/f_eyeshape_hooded_grey.7c04949b.png";